import type { CSSProperties } from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import AddIconMui from '@mui/icons-material/Add';
import SendIconMui from '@mui/icons-material/Send';
import StopIconMui from '@mui/icons-material/Stop';
import EditIconMui from '@mui/icons-material/Edit';
import DeleteIconMui from '@mui/icons-material/Delete';
import ChevronLeftIconMui from '@mui/icons-material/ChevronLeft';
import ChevronRightIconMui from '@mui/icons-material/ChevronRight';
import CalendarMonthIconMui from '@mui/icons-material/CalendarMonth';
import ChatBubbleOutlineIconMui from '@mui/icons-material/ChatBubbleOutline';
import ExpandMoreIconMui from '@mui/icons-material/ExpandMore';
import ExpandLessIconMui from '@mui/icons-material/ExpandLess';
import LogoutIconMui from '@mui/icons-material/Logout';
import CloseIconMui from '@mui/icons-material/Close';
import CheckCircleIconMui from '@mui/icons-material/CheckCircle';
import ErrorIconMui from '@mui/icons-material/Error';
import ViewColumnIconMui from '@mui/icons-material/ViewColumn';
import ZoomOutMapIconMui from '@mui/icons-material/ZoomOutMap';
import ImageIconMui from '@mui/icons-material/Image';
import PostAddIconMui from '@mui/icons-material/PostAdd';
import MenuIconMui from '@mui/icons-material/Menu';
import PercentIconMui from '@mui/icons-material/Percent';
import ListIconMui from '@mui/icons-material/List';
import KeyboardArrowUpIconMui from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIconMui from '@mui/icons-material/KeyboardArrowDown';
import DescriptionIconMui from '@mui/icons-material/Description';
import AttachFileIconMui from '@mui/icons-material/AttachFile';
import DownloadIconMui from '@mui/icons-material/SaveAlt';
import ArrowForwardIconMui from '@mui/icons-material/ArrowForward';
import ContentPasteSearchIconMui from '@mui/icons-material/ContentPasteSearch';
import SearchIconMui from '@mui/icons-material/Search';
import HeadsetMicIconMui from '@mui/icons-material/HeadsetMic';
import TextDecreaseIconMui from '@mui/icons-material/TextDecrease';
import VisibilityIconMui from '@mui/icons-material/Visibility';
import VisibilityOffIconMui from '@mui/icons-material/VisibilityOff';
import PersonIconMui from '@mui/icons-material/Person';
import PersonOffIconMui from '@mui/icons-material/PersonOff';
import TuneIconMui from '@mui/icons-material/Tune';
import BuildIconMui from '@mui/icons-material/Build';
import InfoIconMui from '@mui/icons-material/Info';
import GroupIconMui from '@mui/icons-material/Group';
import EventIconMui from '@mui/icons-material/Event';
import ViewListIconMui from '@mui/icons-material/ViewList';
import PollIconMui from '@mui/icons-material/Poll';
import WarningIconMui from '@mui/icons-material/Warning';
import DoneIconMui from '@mui/icons-material/Done';
import DoneAllIconMui from '@mui/icons-material/DoneAll';
import PushPinIconMui from '@mui/icons-material/PushPin';
import ReplyIconMui from '@mui/icons-material/Reply';
import ForwardIconMui from '@mui/icons-material/Forward';
import BookmarkIconMui from '@mui/icons-material/Bookmark';
import ShortcutIconMui from '@mui/icons-material/Shortcut';
import FilterAltIconMui from '@mui/icons-material/FilterAlt';
import FilterAltOffIconMui from '@mui/icons-material/FilterAltOff';
import ReplayIconMui from '@mui/icons-material/Replay';
import UndoIconMui from '@mui/icons-material/Undo';
import RedoIconMui from '@mui/icons-material/Redo';

interface IconProps {
  size?: number;
  className?: string;
}

const defaultSize = 24;

function withSize(Icon: React.ComponentType<SvgIconProps>, defaultS = defaultSize) {
  return function IconWithSize({ size = defaultS, className, ...props }: IconProps & SvgIconProps) {
    return <Icon sx={{ fontSize: size }} className={className} {...props} aria-hidden />;
  };
}

export const AddIcon = withSize(AddIconMui);
export const SendIcon = withSize(SendIconMui);
export const StopIcon = withSize(StopIconMui);
export const EditIcon = withSize(EditIconMui);
export const DeleteIcon = withSize(DeleteIconMui);
export const ChevronLeftIcon = withSize(ChevronLeftIconMui);
export const ChevronRightIcon = withSize(ChevronRightIconMui);
export const CalendarMonthIcon = withSize(CalendarMonthIconMui);
export const ChatBubbleOutlineIcon = withSize(ChatBubbleOutlineIconMui);
export const ExpandMoreIcon = withSize(ExpandMoreIconMui);
export const ExpandLessIcon = withSize(ExpandLessIconMui);
export const LogoutIcon = withSize(LogoutIconMui);
export const CloseIcon = withSize(CloseIconMui);
export const CheckCircleIcon = withSize(CheckCircleIconMui);
export const ErrorIcon = withSize(ErrorIconMui);
export const ViewColumnIcon = withSize(ViewColumnIconMui);
export const ZoomOutMapIcon = withSize(ZoomOutMapIconMui);
export const ImageIcon = withSize(ImageIconMui);
export const PostAddIcon = withSize(PostAddIconMui);
export const MenuIcon = withSize(MenuIconMui);
export const PercentIcon = withSize(PercentIconMui);
export const ListIcon = withSize(ListIconMui);
export const KeyboardArrowUpIcon = withSize(KeyboardArrowUpIconMui);
export const KeyboardArrowDownIcon = withSize(KeyboardArrowDownIconMui);
export const DescriptionIcon = withSize(DescriptionIconMui);
export const AttachFileIcon = withSize(AttachFileIconMui);
export const DownloadIcon = withSize(DownloadIconMui);
export const ArrowForwardIcon = withSize(ArrowForwardIconMui);
export const ContentPasteSearchIcon = withSize(ContentPasteSearchIconMui);
export const SearchIcon = withSize(SearchIconMui);
export const HeadsetMicIcon = withSize(HeadsetMicIconMui);
export const TextDecreaseIcon = withSize(TextDecreaseIconMui);
export const VisibilityIcon = withSize(VisibilityIconMui);
export const VisibilityOffIcon = withSize(VisibilityOffIconMui);
export const PersonIcon = withSize(PersonIconMui);
export const PersonOffIcon = withSize(PersonOffIconMui);
export const TuneIcon = withSize(TuneIconMui);
export const BuildIcon = withSize(BuildIconMui);
export const InfoIcon = withSize(InfoIconMui);
export const GroupIcon = withSize(GroupIconMui);
export const EventIcon = withSize(EventIconMui);
export const ViewListIcon = withSize(ViewListIconMui);
export const PollIcon = withSize(PollIconMui);
/** История изменений — Font Awesome (единая иконка во всём UI) */
export function HistoryIcon({ size = 18, className }: IconProps) {
  return (
    <i
      className={['fa-solid', 'fa-hourglass-half', className].filter(Boolean).join(' ')}
      style={{
        fontSize: size,
        width: size,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      aria-hidden
    />
  );
}
export const WarningIcon = withSize(WarningIconMui);
export const DoneIcon = withSize(DoneIconMui, 20);
export const DoneAllIcon = withSize(DoneAllIconMui, 20);
export const PushPinIcon = withSize(PushPinIconMui, 18);
export const ReplyIcon = withSize(ReplyIconMui);
export const ForwardIcon = withSize(ForwardIconMui);
export const BookmarkIcon = withSize(BookmarkIconMui);
export const ShortcutIcon = withSize(ShortcutIconMui);
export const FilterAltIcon = withSize(FilterAltIconMui);
export const FilterAltOffIcon = withSize(FilterAltOffIconMui);
export const ReplayIcon = withSize(ReplayIconMui, 20);
export const UndoIcon = withSize(UndoIconMui, 20);
export const RedoIcon = withSize(RedoIconMui, 20);

/** Font Awesome 6 (stylesheet в index.html) — пункты меню и стрип мессенджера. */
const MESSENGER_FA_CLASSES = {
  share: 'fa-solid fa-share',
  replyd: 'fa-brands fa-replyd',
  'circle-check': 'fa-solid fa-circle-check',
  pencil: 'fa-solid fa-pencil',
  icons: 'fa-solid fa-icons',
  /** Как пункт «Мини-приложения» в NavbarAppMenu (`fa-puzzle-piece`). */
  puzzlePiece: 'fa-solid fa-puzzle-piece',
} as const;

export type MessengerFaIconName = keyof typeof MESSENGER_FA_CLASSES;

export function FaMessengerIcon({
  icon,
  size = 18,
  className,
  style,
}: {
  icon: MessengerFaIconName;
  size?: number;
  className?: string;
  style?: CSSProperties;
}) {
  const cls = MESSENGER_FA_CLASSES[icon];
  return (
    <i
      className={[cls, 'fa-fw', className].filter(Boolean).join(' ')}
      style={{
        fontSize: size,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      aria-hidden
    />
  );
}
